/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Active_20ms_LatencyInputs */

const en_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Active • 20ms Latency`)
};

const es_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización Activa • Latencia 20ms`)
};

const fr_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisation active • Latence 20ms`)
};

const de_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync Aktiv • 20ms Latenz`)
};

const ja_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同期アクティブ • 遅延20ms`)
};

const zh_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步已激活 • 20ms 延迟`)
};

const ar_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المزامنة نشطة • زمن استجابة 20ms`)
};

const id_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinkronisasi Aktif • Latensi 20ms`)
};

const it_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronizzazione Attiva • 20ms di Latenza`)
};

const ru_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синхронизация активна • Задержка 20мс`)
};

const pt_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronização Ativa • Latência 20ms`)
};

const ko_sync_active_20ms_latency = /** @type {(inputs: Sync_Active_20ms_LatencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동기화 활성화됨 • 지연 시간 20ms`)
};

/**
* | output |
* | --- |
* | "Sync Active • 20ms Latency" |
*
* @param {Sync_Active_20ms_LatencyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sync_active_20ms_latency = /** @type {((inputs?: Sync_Active_20ms_LatencyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Active_20ms_LatencyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sync_active_20ms_latency(inputs)
	if (locale === "es") return es_sync_active_20ms_latency(inputs)
	if (locale === "fr") return fr_sync_active_20ms_latency(inputs)
	if (locale === "de") return de_sync_active_20ms_latency(inputs)
	if (locale === "ja") return ja_sync_active_20ms_latency(inputs)
	if (locale === "zh") return zh_sync_active_20ms_latency(inputs)
	if (locale === "ar") return ar_sync_active_20ms_latency(inputs)
	if (locale === "id") return id_sync_active_20ms_latency(inputs)
	if (locale === "it") return it_sync_active_20ms_latency(inputs)
	if (locale === "ru") return ru_sync_active_20ms_latency(inputs)
	if (locale === "pt") return pt_sync_active_20ms_latency(inputs)
	return ko_sync_active_20ms_latency(inputs)
});